import Vue from 'vue';
import parseJwt from '../helpers';

export const globalStore = new Vue({
    data: {
      salaryRowDefinitions: null,
      selectedUser: null,
      users: null,
      companies: null,
      version: '0.13',
      loginState: {
          user: null,
          userInfo: null,
          isAdministrator : false,
          isSuperUser : false,
          init() {
              var user = JSON.parse(localStorage.getItem('user'));
              var userInfo = JSON.parse(localStorage.getItem('userInfo'));
              
              if(user) {
                  this.isEmployee = (user.isEmployee);
                  this.isAuditor = (user.role == "Auditor" || user.role == "Administrator" || user.role == "SuperUser");
                  this.isAdministrator = (user.role == "Administrator" || user.role == "SuperUser");
                  this.isSuperUser =  user.role == "SuperUser";
                  this.user = user;
                  localStorage.setItem('userInfo', JSON.stringify({user: user.name, image:user.image}))
              }
              else {
                  this.user = null;
              }

              if(userInfo) {
                  this.userInfo = userInfo;
              }
          },
          logout() {
            localStorage.removeItem('user');
            this.user = null;
          }
        }
    }
  })
  